import { createReducer } from 'redux-act';
import {
  setQuestionState,
  resetQuestionState,
  setQuestionProgress,
  resetQuestionProgress,
  setQuestionSuggest,
  resetQuestionSuggest,
  sendUpdateData,
  failSendUpdateData,
  successSendUpdateData,
  restoreData,
  setData,
  resetData,
  getProgressRank,
  successGetProgressRank,
  failGetProgressRank,
  updatePrintCount,
  uploadSearchKeyword,
  setDayProgress,
  resetDayProgress,
  getDayProgressSummary,
  failGetDayProgressSummary,
  successGetDayProgressSummary,
} from '../actions/user-data';
import moment from 'moment';
//[reducer] ../actions/{module_name}.jsで定義された内容を元に
//内部変数を変更する。
//component にて this.props.dispatch({actionName}());
//または
//redux-saga を使っている場合は ../saga/{module}.js から呼び出される。
//{actionName(param)} の引数param は props.dispatchで呼び出された場合は sagaに
// sagaで callによって呼び出されたときは reducer(このファイル)にて処理される。
//reducer を新規に作成した後は /reducer/index.js にも追記のこと。
//[actionName] :state =>
//[actionName] :(state,param) =>  ...{ationName(param)}
//[actionName] :() =>

//初期状態
const initial = {
  userData: {
    questionState: [],
    questionProgress: [],
    questionSuggest: [],
    rankProgress: undefined,
  },
};
/*
questionState {
  [] = {
    understanding:undefined,

  }
}
*/
const userData = createReducer(
  {
    [updatePrintCount]: (state) => {
      let printCount = 0;
      if (state.printCount != null) {
        printCount = state.printCount + 1;
      }
      return Object.assign({}, state, {
        printCount: printCount,
      });
    },
    [uploadSearchKeyword]: (state) => {
      return Object.assign({}, state, {});
    },
    [setQuestionState]: (state, payload) =>
      Object.assign({}, state, {
        questionState: payload,
      }),
    [resetQuestionState]: (state) =>
      Object.assign({}, state, {
        questionState: [],
        resetQuestionStateDate: moment().format(),
      }),
    [setQuestionProgress]: (state, payload) =>
      Object.assign({}, state, {
        questionProgress: payload,
      }),
    [resetQuestionProgress]: (state) =>
      Object.assign({}, state, {
        questionProgress: [],
        resetQuestionProgressDate: moment().format(),
      }),
    [setQuestionSuggest]: (state, payload) =>
      Object.assign({}, state, {
        questionSuggest: payload,
      }),
    [resetQuestionSuggest]: (state) =>
      Object.assign({}, state, {
        questionSuggest: [],
        resetQuestionSuggestDate: moment().format(),
      }),
    [setDayProgress]: (state, payload) =>
      Object.assign({}, state, {
        dayProgress: payload,
      }),
    [resetDayProgress]: (state) =>
      Object.assign({}, state, {
        dayProgress: [],
        resetDayProgressDate: moment().format(),
      }),
    [sendUpdateData]: (state) =>
      Object.assign({}, state, {
        isFetching: true,
        error: undefined,
      }),
    [failSendUpdateData]: (state, err) =>
      Object.assign({}, state, {
        isFetching: false,
        error: err,
      }),
    [successSendUpdateData]: (state, payload) =>
      Object.assign({}, state, {
        isFetching: false,
        lastUpdate: payload.now,
        error: undefined,
      }),
    [resetData]: (state) => Object.assign({}, initial.userData),
    [setData]: (state, payload) => Object.assign({}, state, payload),
    [restoreData]: (state, payload) => Object.assign({}, payload),
    [getProgressRank]: (state) =>
      Object.assign({}, state, {
        isFetching: true,
        error: undefined,
      }),
    [failGetProgressRank]: (state, err) =>
      Object.assign({}, state, {
        isFetching: false,
        error: err,
      }),
    [successGetProgressRank]: (state, payload) =>
      Object.assign({}, state, {
        isFetching: false,
        rankProgress: payload,
        error: undefined,
      }),
    [getDayProgressSummary]: (state) =>
      Object.assign({}, state, {
        isFetching: true,
        error: undefined,
      }),
    [failGetDayProgressSummary]: (state, err) =>
      Object.assign({}, state, {
        isFetching: false,
        error: err,
      }),
    [successGetDayProgressSummary]: (state, payload) =>
      Object.assign({}, state, {
        isFetching: false,
        dayProgressSummary: payload.data,
        error: undefined,
      }),
  },
  initial.userData
);

export default userData;



// WEBPACK FOOTER //
// ./src/reducers/user-data.js